<template>
	<div class="exercise analysis">
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="card">
					<h5>Records</h5>
					<ContentActivityTable :event="event"></ContentActivityTable>
					<!-- {{ event }} -->
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import ActivityAnalysis from '.'
import ActivityTable from './Table'
import ContentActivityTable from './ContentTable'

export default {
	extends: ActivityAnalysis,

	props: {
		type: {
			type: String
		}
	},

	components: {
		ActivityTable,
		ContentActivityTable
	}
}
</script>

<style lang="scss" scoped>
@import "../../../component/table/style/analysis.scss";
</style>
